export const VERSION = '1.0.1.2';
export const PAST_DAYS = 10;
export const FUTURE_DAYS = 14;
export const WORK_DAYS = [1, 2, 3, 4, 5];

export const COMPANY = 'BS';
//Lokalno
export const ServerUri='http://localhost:51881';
//BS live
//export const ServerUri='https://lieferapp.broemse.de';
//export const ServerUri='https://lieferapp.menck-fenster.de';
//export const ServerUri='http://192.168.1.12/lieferanten_DB';